module.exports = __webpack_public_path__ + "static/img/UTSC老师_Bobby.c968364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_Bobby.png
// module id = lRl6
// module chunks = 0